/**
 * Sends Google Tag Event on View Cart
 *
 */
export const sendViewCartEvent = function () {
  fetch('/cart.json')
    .then((response) => {
      return response.text()
    })
    .then((responseText) => {
      const json = JSON.parse(responseText)
      const currency = json.currency
      const value = json.total_price

      const items = json.items.map((item) => {
        return { item_id: item.product_id.toString(), item_name: item.title }
      })

      const data = {
        currency: currency,
        value: value,
        items: items,
      }

      if (gtag && typeof gtag === 'function') {
        gtag('event', 'view_cart', data)
      }
    })
}

/**
 * Sends Google Tag Event on View Item
 *
 */
const sendViewItemEvent = function () {
  const url = window.location.href + '.json'

  fetch('/cart.json')
    .then((response) => response.json())
    .then((json) => {
      const currency = json.currency

      fetch(url)
        .then((response) => response.json())
        .then((json) => {
          const price = parseFloat(json.product.variants[0].price)

          const data = {
            currency: currency,
            value: price,
            items: [
              {
                item_id: json.product.id.toString(),
                item_name: json.product.title,
              },
            ],
          }

          if (gtag && typeof gtag === 'function') {
            gtag('event', 'view_item', data)
          }
        })
    })
}

/**
 * Sends Google Tag Event on View Item List
 *
 */
const sendViewItemListEvent = function () {
  const url = window.location.href + '.json'

  fetch(window.location.href)
    .then((response) => response.text())
    .then((data) => {
      const parser = new DOMParser()
      const htmlDoc = parser.parseFromString(data, 'text/html')
      const script = htmlDoc.querySelector('#collection-schema')

      const items = JSON.parse(script.innerHTML).itemListElement.map((item) => {
        return { item_id: item.id, item_name: item.name }
      })

      fetch(url)
        .then((response) => response.json())
        .then((json) => {
          const data = {
            item_list_id: json.collection.id.toString(),
            item_list_name: json.collection.title,
            items: items,
          }

          if (gtag && typeof gtag === 'function') {
            gtag('event', 'view_item_list', data)
          }
        })
    })
}

export const sendSignUpEvent = function (method) {
  if (gtag && typeof gtag === 'function') {
    gtag('event', 'sign_up', {
      method: method,
    })
  }
}

export const sendLoginEvent = function (method) {
  if (gtag && typeof gtag === 'function') {
    gtag('event', 'login', {
      method: method,
    })
  }
}

const sendSearchEvent = function (search_term) {
  if (gtag && typeof gtag === 'function') {
    gtag('event', 'search', {
      search_term: search_term,
    })
  }
}

window.HH = window.HH || {}

window.HH = {
  sendViewItemEvent,
  sendViewItemListEvent,
  sendSignUpEvent,
  sendSearchEvent,
  ...window.HH,
}
